import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
export default new Router({
  // mode: 'history',
  // base: '/mobile/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['../views/home'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      path: '/index.html',
      name: 'home',
      component: resolve => require(['../views/home'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['../views/home'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'know',
      path: '/know',
      component: resolve => require(['../views/mine/know'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'success',
      path: '/success',
      component: resolve => require(['../views/mine/success'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'contact',
      path: '/contact',
      component: resolve => require(['../views/mine/contact'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'serve',
      path: '/serve',
      component: resolve => require(['../views/mine/serve'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'owner',
      path: '/owner',
      component: resolve => require(['../views/mine/owner'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'add',
      path: '/add',
      component: resolve => require(['../views/mine/add'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'analysis',
      path: '/analysis',
      component: resolve => require(['../views/mine/analysis'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'trend',
      path: '/trend',
      component: resolve => require(['../views/mine/trend'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'society',
      path: '/society',
      component: resolve => require(['../views/mine/society'], resolve),
      meta: {
        title: '赞百'
      }
    },
    {
      name: 'school',
      path: '/school',
      component: resolve => require(['../views/mine/school'], resolve),
      meta: {
        title: '赞百'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js